<template>
  <ElCollapse
    v-model="active"
    class="el-collapse--plain"
  >
    <ElCollapseItem :name="NAME">
      <template #title="{ isActive }">
        <div class="flex flex-row items-center justify-start gap-2 my-2">
          <FaIcon
            name="chevron-down"
            size="sm"
            class="text-secondary"
            :rotation="isActive ? '180' : undefined"
          />
          <h5 class="mb-0">
            {{ name }}
          </h5>
        </div>
      </template>
      <!-- Die Stelle stellt ihren Pfeil selbst. Ein leerer `#icon`-Slot reicht
           nicht: EP fällt dann auf sein eigenes Icon zurück. -->
      <template #icon>
        <span class="hidden" />
      </template>
      <div class="flex flex-wrap mt-2.5 mb-5">
        <div class="w-full md:w-1/2">
          <h6
            class="font-bold mb-0"
            v-text="headline"
          />
          <p
            class="mb-0"
            v-text="text"
          />
        </div>
        <div class="w-full md:w-1/2 flex items-center justify-center">
          <SvgVue
            :icon="img"
            class="h-full"
          />
        </div>
      </div>
      <div v-if="tableEntries.length > 0">
        <table class="data-table Table mt-7 lg:mt-0">
          <thead>
            <tr
              :class="$style.colWidths"
            >
              <th>
                <div>Versicherer</div>
                <div>Produktbezeichnung</div>
              </th>
              <th>Kapitalanlage</th>
              <th>Einflussmöglichkeit des Kunden</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="({
                versicherer,
                produktbezeichnung,
                kapitalanlage,
                einflussKunde,
              }, idx) in tableEntries"
              :key="idx"
              :class="$style.colWidths"
            >
              <td>
                {{ versicherer }} <br>
                {{ produktbezeichnung }} <br>
              </td>
              <td>
                <template v-if="kapitalanlage.length < 150">
                  {{ kapitalanlage }}
                </template>
                <ShowMoreWrapper
                  v-else
                  :text="kapitalanlage"
                  :arrow-color="$style.arrowColor"
                />
              </td>
              <td>
                <template v-if="einflussKunde.length < 150">
                  {{ einflussKunde }}
                </template>
                <ShowMoreWrapper
                  v-else
                  :text="einflussKunde"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </ElCollapseItem>
  </ElCollapse>
</template>

<script setup lang="ts">
import FaIcon from '@/application/components/ui/FaIcon.vue';
import { ElCollapse, ElCollapseItem } from 'element-plus';
import ShowMoreWrapper from '@/bedarf/components/altersvorsorge/altersvorsorge/finder/ShowMoreWrapper.vue';
import SvgVue from "@/application/components/SvgVue";
import type { TableEntry } from "@/bedarf/components/altersvorsorge/altersvorsorge/finder/types";
import { ref, watch } from 'vue';

interface Props {
  name: string;
  headline: string;
  text: string;
  img: string;
  imgAlt: string;
  tableEntries: TableEntry[];
  open: boolean;
}

const props = defineProps<Props>();

const NAME = 'body';

const active = ref<string[]>(props.open ? [NAME] : []);

watch(() => props.open, (open) => {
  active.value = open ? [NAME] : [];
});
</script>

<style lang="scss" module>
$white: #FFF;
$black: #000;
$blue: #4181D2;
$blue-light: #D8E7F7;
$light: #F2F2F5;

.arrowColor {
  color: $blue;
}

.zebraStripesLight {
  :nth-child(odd) {
    background-color: $light;
  }
}

.colWidths {
  > :nth-child(1) {
    width: 20%;
  }

  > :nth-child(2) {
    width: 40% !important;
  }

  > :nth-child(3) {
    width: 40% !important;
  }
}
</style>
